import React from "react";
import { ROUTES } from "constant";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import { Login } from "screens";
// import { ProtectedRoutes } from "./components";
import ForgetPasswords from "screens/ForgetPasswords/ForgetPasswords";
import EnterCode from "screens/EnterCode/EnterCode";
import PaymentManagement from "screens/PaymentManagement/PaymentManagement";
import Settings from "screens/Settings/Settings";
import MyContent from "screens/MyContent/MyContent";
import MyEarnings from "screens/MyEarnings/MyEarnings";
import Discover from "screens/Discover/Discover";
import MyLearning from "screens/MyLearning/MyLearning";
import Users from "screens/Users/Users";
import PersonalUserInfo from "screens/PersonalUserInfo/PersonalUserInfo";
import PersonalUserStandard from "screens/PersonalUserInformation/PersonalUserInformation";
import Contents from "screens/Contents/Contents";
import ContentEdit from "screens/ContentEdit/Contents";
import PendingVerification from "screens/PendingVerification/PendingVerification";
import Refunds from "screens/Refunds/Refunds";
import Register from "screens/Register/Register";
import LegalitiesPolicy from "screens/LegalitiesPolicy/LegalitiesPolicy";
import Receipt from "screens/Receipt/Refunds";
import DiscoverDetail from "screens/DiscoverDetail/DiscoverDetail";
import ProfileView from "screens/ProfileView/ProfileView";
import LearningLog from "screens/LearningLog/LearningLog";
import CreateHandout from "screens/CreateHandout/CreateHandout";
import CreateCourse from "screens/CreateCourse/CreateCourse";
import Cart from "screens/Cart/Cart";
import CheckOut from "screens/CheckOut/CheckOut";
import ReviewEducationContent from "screens/ReviewEducationContent/ReviewEducationContent";
import HandoutOverView from "screens/HandoutOverView/HandoutOverView";
import EducationContentCourse from "screens/EducationContentCourse/EducationContentCourse";
import BestSellingCourse from "screens/BestSellingCourse/BestSellingCourse";
import BestSellingHandout from "screens/BestSellingHandout/BestSellingHandout";
import ResetEmail from "screens/ResetEmail/ResetEmail";
import BecomeContentCreator from "screens/BecomeContentCreator/BecomeContentCreator";
import ProtectedRoute from "./ProtectedRoute";
import ViewContentStruture from "screens/ViewContentStruture";

type Props = {};

const Routes = (props: Props) => {
  return (
    <ReactRoutes>
      {/* Auth Routes */}
      <Route path={ROUTES.LOGIN} element={<Login />} />
      {/* <Route path={ROUTES.LOGIN} element={<Login />} /> */}
      <Route path={ROUTES.REGISTER} element={<Register />} />
      <Route path={ROUTES.FORGOT_PASSWORDS} element={<ForgetPasswords />} />
      <Route path={ROUTES.RESET_EMAIL} element={<ResetEmail />} />
      <Route path={ROUTES.LEGALITIES_POLICY} element={<LegalitiesPolicy />} />
      <Route path={ROUTES.ENTER_CODE} element={<EnterCode />} />
      {/* App Routes */}
      <Route path={"/"} element={<Discover />} />
      <Route path={ROUTES.DISCOVER_DETAIL} element={<DiscoverDetail />} />
      <Route
        path={ROUTES.BEST_SELLING_COURSE}
        element={<BestSellingCourse />}
      />
      <Route
        path={ROUTES.BEST_SELLING_HANDOUT}
        element={<BestSellingHandout />}
      />
      <Route
        path={ROUTES.MY_LEARNING}
        element={
          <ProtectedRoute>
            <MyLearning />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.LEARNING_LOG}
        element={
          <ProtectedRoute>
            <LearningLog />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PAYMENT_MANAGEMENT}
        element={
          <ProtectedRoute>
            <PaymentManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PAYMENT_MANAGEMENT_RECIPT}
        element={
          <ProtectedRoute>
            <Receipt />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.SETTINGS}
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.BECOME_CONTENT_CREATOR}
        element={
          <ProtectedRoute>
            <BecomeContentCreator />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.MY_CONTENT}
        element={
          <ProtectedRoute>
            <MyContent />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CREATE_HANDOUT}
        element={
          <ProtectedRoute>
            <CreateHandout />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CREATE_COURSE}
        element={
          <ProtectedRoute>
            <CreateCourse />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.MY_EARNINGS}
        element={
          <ProtectedRoute>
            <MyEarnings />
          </ProtectedRoute>
        }
      />
      <Route path={ROUTES.USERS} element={<Users />} />
      <Route
        path={ROUTES.USERS_USER_PERSONAL_INFO}
        element={
          <ProtectedRoute>
            <PersonalUserInfo />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.USERS_USER_PERSONAL_INFOMATION}
        element={
          <ProtectedRoute>
            <PersonalUserStandard />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CONTENTS}
        element={
          <ProtectedRoute>
            <Contents />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CONTENTS_EDIT}
        element={
          <ProtectedRoute>
            <ContentEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PENDING_REFUND}
        element={
          <ProtectedRoute>
            <Refunds />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PENDING_VERIFICATION}
        element={
          <ProtectedRoute>
            <PendingVerification />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PROFILE_VIEW}
        element={
          <ProtectedRoute>
            <ProfileView />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CART}
        element={
          <ProtectedRoute>
            <Cart />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CHECKOUT}
        element={
          <ProtectedRoute>
            <CheckOut />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.REVIEW_EDUCATION_CONTENT}
        element={<ReviewEducationContent />}
      />
      <Route
        path={ROUTES.View_CONTENT_STRUCTURE}
        element={<ViewContentStruture />}
      />
      <Route
        path={ROUTES.EDUCATION_HANDOUT_OVERVIEW}
        element={<HandoutOverView />}
      />
      <Route
        path={ROUTES.EDUCATION_CONTENT_COURSE}
        element={<EducationContentCourse />}
      />
    </ReactRoutes>
  );
};

export default Routes;
